import { Box, CircularProgress } from '@mui/material'
import React, { useEffect, useRef } from 'react'
import { trackWindowScroll } from 'react-lazy-load-image-component'
import 'swiper/css'
import 'swiper/css/navigation'
import { VodRowViewProps } from '@/types/vod/vodRowType'
import VodSlider from './VodSlider'
import { useVodItemsContext } from '@/features/VOD/context/UseGetVodItemContext/useVodItemsContext'
import { isSmartTV, isStreamIQ, isToya } from '@/shared/lib'
import { getVodRecommendationStreamIQSlider } from '@/shared/getContainer/VodRecommendationStreamIQSlider'
import VodRowRecommendationsTV from '@/appTV/VOD/components/VodRowRecommendationsTVApp'

const VodRecommendationStreamIQSlider =
    await getVodRecommendationStreamIQSlider()

const VodRowViewRecommendations = ({
    handleGoToCategoryButtonClick,
    scrollPosition,
    maxHeight,
}: VodRowViewProps) => {
    const itemsContainerRef = useRef<HTMLDivElement>(null)
    const vodItemHeight = maxHeight
    const { getItems, isError, isLoading } = useVodItemsContext()

    useEffect(() => {
        const rowElement = itemsContainerRef.current
        if (rowElement) {
            rowElement.addEventListener('scroll', () => getItems())
            return () =>
                rowElement.removeEventListener('scroll', () => getItems())
        }
    })

    const rowViewContainerStyle = {
        pt: '2px',
        pb: '76px',
        position: 'relative',
        width: '99%',
    }

    const messageStyle = {
        position: 'absolute',
        left: '50% !important',
        top: ' 50% !important',
        transform: 'translate(-50%, -50%)',
    }

    const renderSlider = () => {
        if (isToya()) {
            return (
                <VodSlider
                    buttonHeight={vodItemHeight}
                    vodItemHeight={vodItemHeight}
                    handleGoToCategoryButtonClick={
                        handleGoToCategoryButtonClick
                    }
                    scrollPosition={scrollPosition}
                />
            )
        }

        if (isStreamIQ() && isSmartTV()) {
            return (
                <VodRowRecommendationsTV
                    maxHeight={vodItemHeight}
                    handleGoToCategoryButtonClick={
                        handleGoToCategoryButtonClick
                    }
                    productId={''}
                    title={''}
                />
            )
        } else if (isStreamIQ()) {
            return (
                <VodRecommendationStreamIQSlider
                    vodItemHeight={vodItemHeight}
                    handleGoToCategoryButtonClick={
                        handleGoToCategoryButtonClick
                    }
                    scrollPosition={scrollPosition}
                />
            )
        }
    }

    return (
        <Box onScroll={() => getItems()} sx={rowViewContainerStyle}>
            {!isError && !isLoading ? (
                renderSlider()
            ) : (
                <Box sx={messageStyle}>
                    <CircularProgress color="inherit" />
                </Box>
            )}
        </Box>
    )
}

export default trackWindowScroll(VodRowViewRecommendations)
